import { render, staticRenderFns } from "./BusquedaCliente.vue?vue&type=template&id=73e8fa40&"
import script from "./BusquedaCliente.vue?vue&type=script&lang=js&"
export * from "./BusquedaCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports